import type React from 'react';

import { compose, mapProps } from 'recompose';

import withCurrentSession, { type PropsFromWithCurrentSession } from 'bundles/course-sessions/utils/withCurrentSession';

type InputProps = {
  courseId: string;
};

export type SessionLabel = 'session' | 'schedule';

export type PropsFromWithSessionLabel = {
  sessionLabel: SessionLabel;
};

export type PropsWithSessionLabel<T> = T & PropsFromWithSessionLabel;

const composed = <PropsFromCaller extends InputProps>(
  PassedComponent: React.ComponentType<PropsWithSessionLabel<PropsFromCaller>>
): React.ComponentType<PropsFromCaller> => {
  type PropsFromCompose = PropsFromCaller & PropsFromWithSessionLabel;
  type PropsToMapProps = PropsFromCaller & PropsFromWithCurrentSession;
  return compose<PropsFromCompose, PropsFromCaller>(
    withCurrentSession,
    // The HOCs-calling-HOCs pattern is very complex.
    // TODO: Just make this accept the currentSession property as input, rather than having this call withCurrentSession just to get currentSession.isPrivate.
    // There are 7 usages of withSessionLabel, and we can just make them all call withCurrentSession beforehand.
    mapProps<PropsFromCompose, PropsToMapProps>((propsToMapProps) => ({
      ...propsToMapProps,
      sessionLabel: propsToMapProps.currentSession?.isPrivate ? 'session' : 'schedule',
    }))
  )(PassedComponent);
};

export default composed;
